// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper-mJK747{width:100%;height:100%}.content-FxpIxN{flex-direction:column;align-items:center;margin:auto;padding-top:35.39vh;display:flex}.title-h1Vtcc{margin-top:24px!important;margin-bottom:4px!important;font-size:16px!important;font-weight:600!important;line-height:22px!important}.paragraph-isj9qQ{color:rgba(29,28,35,.6);margin-bottom:8px;font-size:12px;line-height:16px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `wrapper-mJK747`,
	"content": `content-FxpIxN`,
	"title": `title-h1Vtcc`,
	"paragraph": `paragraph-isj9qQ`
};
export default ___CSS_LOADER_EXPORT___;
